import { useState } from "react";
import { categoryTags, feedNews } from "@/mocks/baoliao";

export default function Feed() {
  const [active, setActive] = useState("all");
  const list = active === "all" ? feedNews : feedNews.filter((n) => n.tagType === active);

  return (
    <section id="feed" className="scroll-mt-20 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6">
          <div>
            <p className="text-xs text-primary-600 font-medium tracking-widest uppercase">LATEST FEED</p>
            <h2 className="mt-1 text-2xl md:text-3xl text-foreground-950">最新线索速递</h2>
          </div>
          {/* 分类标签切换 */}
          <div className="inline-flex items-center gap-1 p-1 rounded-full bg-background-200/70 flex-wrap w-full sm:w-auto">
            {categoryTags.map((tag) => (
              <button
                key={tag.key}
                type="button"
                onClick={() => setActive(tag.key)}
                className={`rounded-full px-3.5 py-1.5 text-sm whitespace-nowrap transition-colors ${
                  active === tag.key
                    ? "bg-foreground-950 text-background-50"
                    : "text-foreground-700 hover:text-foreground-950"
                }`}
              >
                {tag.label}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {list.map((item) => (
            <article
              key={item.id}
              className="group overflow-hidden rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-colors animate-rise-in"
            >
              <a href="#feed" className="block sm:flex">
                <div className="relative h-40 sm:w-44 sm:h-auto overflow-hidden shrink-0">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-5 flex-1">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className="inline-flex items-center gap-1 rounded-full bg-primary-100 text-primary-800 px-2 py-0.5 text-xs whitespace-nowrap">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                  </div>
                  <h3 className="text-base text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{item.summary}</p>
                  <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-user-line" />
                      {item.author}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-eye-line" />
                      {item.views}
                    </span>
                  </div>
                </div>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}